// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginForm_wrapper__Xlq+1","card":"LoginForm_card__eBn8f","title":"LoginForm_title__j+Cv3","alert":"LoginForm_alert__eUw7U","submit":"LoginForm_submit__J1NIu"};